import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getFaqs = () => getJson('/api/faq');
export const getFaq = (id) => getJson(`/api/faq/${id}`);
export const createFaq = (f) => withDone(withValidate(postJson('/api/faq', f)))();
export const updateFaq = (f) => withDone(withValidate(putJson('/api/faq', f)))();
export const deleteFaq = (id) => withDone(deleteJson(`/api/faq/${id}`))();
